module.exports = __webpack_public_path__ + "static/media/radiobutton-on.269ae6c6.svg";